<template>
  <section>
    <div id="cardCont">
      <img id="servIcon" src="../../assets/cardIcons/serverCard_250x250.svg" alt="Server Icon" :class=" { 'icon-visible': zoneIsActive, 'icon-hidden': zoneNotActive }" />
      <div id="cardText">
        <h1 :class=" { 'visible': zoneIsActive, 'hidden': zoneNotActive }"><span>IT,</span> SIMPLIFIED</h1>
        <h2 :class=" { 'visible': zoneIsActive, 'hidden': zoneNotActive }">Technology that <span>works for your business</span>, not the other way around.</h2>
      </div>
    </div>
  </section>
</template>

<script>
  
  export default {
    name: 'HomeSection',
    
    components: {
      
    },
    
    data() {
      return {
        
      }
    },
    
    computed: {
      zoneIsActive() {
        return this.$store.state.activeSections.home;
      },
      zoneNotActive() {
        return !this.$store.state.activeSections.home;
      }
    },
    
    methods: {
      
    }
  }
  
</script>

<style scoped>

  section {
    width: 100%;
    min-width: 320px;
    min-height: 100vh;
    border: solid blue 0px;
    display: flex; 
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-image: linear-gradient(180deg, rgb(250,250,250) 0%, rgb(237,235,242) 100%);
    transition: background-position, 400ms;
  }
  
  span {
    color: rgb(103, 35, 184);
    font-weight: bold;
  }
  
  h1 {
    font-family: Futura,Trebuchet MS,Arial,sans-serif;
    font-weight: normal;
    font-size: 42px;
    border: solid yellow 0px;
    position: relative;
    text-shadow: 0px 2px 6px rgba(0, 0, 0, .2);
    margin: 0px 0px 10px 0px;
    transition: all 700ms cubic-bezier(.47,0,.2,1);
    transition-delay: 500ms;
    color: rgb(0,0,0);
  }
  
  h2 {
    font-weight: normal;
    font-size: 23px;
    border: solid red 0px;
    transition: all 700ms cubic-bezier(.47,0,.2,1);
    transition-delay: 800ms;
    color: rgb(0,0,0);
  }
  
  .visible {
    opacity: 1;
  }
  
  .hidden {
    opacity: 0;
  }
  
  #cardCont {
    border: solid green 0px;
    width: 100%;
    /* min-width: 300px; */
    max-width: 800px;
    min-height: 400px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
  
  #servIcon {
    min-width: 180px;
    min-height: 180px;
    max-width: 250px;
    max-height: 250px;
    width: 40vmin;
    height: 40vmin;
    transition: all 500ms cubic-bezier(.75,0,.29,1.4);
  }
  
  .icon-hidden {
    transform: scale(0);
  }
  
  .icon-visible {
    transform: scale(1);
  }
  
  #cardText {
    /*font-family: "Arial Black", Gadget, sans-serif;*/
    max-width: 450px;
    max-height: 140px;
    width: 100%;
    /* height: 40vmin; */
    border: solid blue 0px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: left;
    text-shadow: 0px 1px 2px rgba(0, 0, 0, .1);
    margin: 0px 0px 0px 18px;
  }

  @media screen and (max-width: 800px) {
    #cardCont {
      flex-direction: column;
    }

    #cardText {
      align-items: center;
      height: 130px;
      margin: 0px;
      width: 95%;
      transform: translateY(-20px);
    }

    h1 {
      font-size: 42px;
      margin: 0px 0px 16px 0px;
    }

    h2 {
      text-align: center;
      font-size: 20px;
    }
  }
  
  @media screen and (max-width: 450px) {
    #cardCont {
      flex-direction: column;
    }

    #cardText {
      align-items: center;
      justify-content: center;
    }

    h1 {
      font-size: 9vw;
      margin: 0px 0px 16px 0px;
    }

    h2 {
      text-align: center;
      font-size: 18px;
    }
  }
  
</style>